import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { ConnectionService } from './connection.service';
import { ConfigService } from './endpoint.config.service';
import { Observable } from 'rxjs';
import { PendingImageUpload, UploadDocumentRequest } from '../models/document-upload.model';


@Injectable({
  providedIn: 'root'
})
export class DocumentService extends ConnectionService {

  constructor(http: HttpClient, private configs: ConfigService) {
    super(http);
   }

    AddDocumentByAWB(SourceID,Reference,FileName,fileContent, sucFun, errFun) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi("post", this.configs.getAppApiUrl("AddDocument_ByAWB")
    .replace("{{SourceID}}", SourceID)
    .replace("{{Reference}}", Reference)
    .replace("{{UserLocationId}}", currentLocationId),
    {FileName: FileName, fileContent: fileContent },null,
      (res) => {
        sucFun(res)
      },
      (err) => {
        try {
          errFun(err.error)
        }
        finally {
 
        }
      }
    );
  }

  UploadShipmentDocumentsAsync(request: UploadDocumentRequest): Observable<any> {
  
    return new Observable(observer => {
      this.CallApi(
        "post",
        this.configs.getAppApiUrl("UploadShipmentDocumentsAsync")
          .replace("{{SourceID}}", request.sourceID)
          .replace("{{Reference}}", request.reference)
          .replace("{{UserLocationId}}", request.userLocationId),
        { FileName: request.fileName, fileContent: request.fileContent },
        null,
        (res) => {
          observer.next(res);
          observer.complete();
        },
        (err) => {
          observer.error(err.error);
        }
      );
    });
  }

  AddDocumentByID(SourceID,Reference,FileName,fileContent, sucFun, errFun) {
    this.CallApi("post", this.configs.getAppApiUrl("AddDocument_ByID").replace("{{SourceID}}", SourceID).replace("{{Reference}}", Reference),
    {FileName: FileName, fileContent: fileContent },null,
      (res) => {
        sucFun(res)
      },
      (err) => {
        try {
          
          errFun(err.error)
        }
        finally {

        }
      }
    );
  }


  DeleteDocumentByAWB(SourceID,Reference,FileName, sucFun, errFun) {
    this.CallApi("post", this.configs.getAppApiUrl("DeleteDocument_ByAWB").replace("{{SourceID}}", SourceID).replace("{{Reference}}", Reference),
    {FileName:FileName}, null,
      (res) => {
        sucFun(res)
      },
      (err) => {
        try {
          
          errFun(err.error)
        }
        finally {

        }
      }
    );
  }

  GetDocumentByAWB(SourceID,Reference,FileName, sucFun, errFun) {
    this.CallApi("post", this.configs.getAppApiUrl("GetDocument_ByAWB").replace("{{SourceID}}", SourceID).replace("{{Reference}}", Reference),
    {FileName: FileName}, null,
      (res) => {
        sucFun(res)
      },
      (err) => {
        try {
          
          errFun(err.error)
        }
        finally {

        }
      }
    );
  }

}
